import { Box, useTheme, Typography } from "@mui/material";
import { toPng } from "html-to-image";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Bar } from "react-chartjs-2";
import DownloadComponentButton from "../../components/button/DownloadComponentButton";
import { getBarOptions } from "../../components/chart/BarChartWithTabs";
import { getColors } from "../../components/chart/DoughnutChart";
import { scope1Categories, scope2Categories, scope3Categories } from "../../pages/Organization/ScopeCategory";

const OrganizationFootprintEnvBarChart = forwardRef(({ emissions }, parentRef) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const barOptions = getBarOptions(isDark);
  const ref = useRef(null);
  const [emissionBarData, setEmissionBarData] = useState({
    labels: [],
    datasets: [],
  });
  useEffect(() => {
    const labels = emissions.map((item) => {
      if (item.is_avoided) return item.category + " (Avoided)";
      if (item.is_biogenic) return item.category + " (Biogenic)";
      return item.category;
    });

    const getScopeColorForCategory = (cat, isAvoided, isBiogenic) => {
      if (isAvoided) return "#22c55e"; // Green
      if (isBiogenic) return "#8b5cf6"; // Purple
      if (scope1Categories.includes(cat)) return "#ef4444"; // Red
      if (scope2Categories.includes(cat)) return "#f59e0b"; // Orange
      if (scope3Categories.includes(cat)) return "#0ea5e9"; // Blue
      return "#64748b"; // Fallback
    };

    const backgroundColor = emissions.map(item => getScopeColorForCategory(item.category, item.is_avoided, item.is_biogenic));
    const borderColor = backgroundColor;

    const data = emissions.map((item) => Math.abs(item.gwp));
    setEmissionBarData({
      labels,
      datasets: [
        {
          label: "GWP",
          data,
          backgroundColor,
          borderColor,
          borderWidth: 1.5,
          borderRadius: 4,
          pointRadius: 3,
          pointHoverRadius: 3,
          pointBackgroundColor: backgroundColor,
          tension: 0.05,
        },
      ],
    });
  }, [emissions]);
  useImperativeHandle(parentRef, () => ({
    getScreenshot: async () => {
      if (ref.current) {
        return await toPng(ref.current, { cacheBust: true, backgroundColor: "#ffffff" });
      }
      return null;
    },
  }));
  return (
    <Box ref={ref} sx={{ p: 4, height: 505, borderRadius: 4, bgcolor: "#ffffff", border: "1px solid #e2e8f0" }}>
      <Typography variant="h6" sx={{ mb: 4, pb: 2, fontWeight: 500, color: "#0f172a", borderBottom: "1px solid #e2e8f0" }}>
        Emissions Breakdown
      </Typography>
      <Box sx={{ width: "100%", height: 380 }}>
        {emissionBarData && <Bar data={emissionBarData} options={barOptions} />}
      </Box>
    </Box>
  );
});

export default OrganizationFootprintEnvBarChart;
